import KogInputTextOutlinedControlled from "@/main/components/shared/inputText/inputTextOutlinedControlled";
import { useFormContext, useWatch } from "react-hook-form";
import { getTranslateByKey } from "@/main/services/utils";
import { QuoteSupplierItemPartResponse } from "@/main/models/response";
import * as S from "../../styles";

interface IWeightInputProps {
	fieldPrefix: string;
	showFieldWithouEdit?: boolean;
	row: QuoteSupplierItemPartResponse;
}

export default function ColumnWeight({ fieldPrefix, showFieldWithouEdit, row }: IWeightInputProps) {
	const { control } = useFormContext();

	const watcherNotQuote = useWatch({
		control,
		name: `${fieldPrefix}.notQuote`,
		defaultValue: false,
	});

	if (row.isInventoryResponse || showFieldWithouEdit) {
		return row.weight > 0 && !row.deliveryBySupplier ? <S.TextAlignTable>{row.weight}</S.TextAlignTable> : <></>;
	}

	return (
		<KogInputTextOutlinedControlled
			id="id-createAnswer-txt-weight"
			hasOnlyNumber
			disabledMessage
			name={`${fieldPrefix}.weight`}
			placeholder={getTranslateByKey("information.weight")}
			label=""
			control={control}
			hideValue={watcherNotQuote}
			disabled={watcherNotQuote}
			inputProps={{ maxLength: 10 }}
			controllerProps={{
				rules: {
					required: !watcherNotQuote,
					maxLength: 10,
					validate: (value) => {
						if (watcherNotQuote) return true;
						const valueFormatted = typeof value === "string" ? value.replace(",", ".") : value;
						return parseFloat(valueFormatted) > 0;
					},
				},
			}}
		/>
	);
}
